import { Validator } from 'vee-validate';
import { EnvironmentConfig } from '../services/constants';


const _rowParams = EnvironmentConfig._Rows;
const _colParams = EnvironmentConfig._Columns;

Validator.extend('rowParameter', {
    validate(value) {
        if((/^[1-9]/).test(value))
            return (value >= 1 && value <= parseInt(_rowParams));
        else
            return false;
    }
});

Validator.extend('colParameter', {
    validate :(value) => {
        if((/^[1-9]/).test(value))
            return (value >= 1 && value <=  parseInt(_colParams));
        else
            return false;
    }
});

Validator.extend('address',{
    validate(value) {
        return ((/^[&#.0-9a-zA-Z\s,-]+$/).test(value));
    }
})

Validator.extend('bankClientValidator',{
    validate(value){
        return((/^[a-zA-Z0-9 ]*$/).test(value));
    }
})

Validator.extend('headersValidator', {
    validate(value) {
        if ((/<(.|\n)*?>/g.test(value))|| !isNaN(value.charAt(0))){
            return false;
        } else {
            return true;
        }
    }
})

export default {
    name: 'AppValidations',
    data() {
        return {
            isDateValid: true
        }
    },
    methods: {
        validateDate(startDate, endDate) {
            if (startDate != null && endDate != null) {
                var diff = (new Date(endDate) - new Date(startDate)) / 1000 / 60 / 60 / 24;
                if (diff < 0) {
                    this.isDateValid = false;
                } else {
                    this.isDateValid = true;
                }
            }
        },
        isNumber(event){
            event = (event) ? event : window.event;
            var charCode = (event.which) ? event.which : event.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                event.preventDefault();
            } else {
                return true;
            }
        }
    }
}
